import React from "react"
import { cn } from "lib/utils" 

export default function GridTableHeader({ 
  name, 
  label,
  sortFn,
  className="" 
} : {
  name:string
  label:string
  sortFn?:any
  className?:string 
}){

  return (
    <div 
      className={cn(
        "col-span-2 flex justify-start items-end font-bold text-sm uppercase cursor-pointer", 
        className
      )}
    >
      { label !== "--" ? label : "" }
    </div>
  )
}